<script>
export default {
  components: {},
};
</script>

<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row g-0">
        <div class="col-xl-9 col-lg-7 order-2 order-lg-1">
          <div class="auth-full-bg pt-lg-5 p-4  h-100">
            <div class="w-100  h-100">
              <div class="bg-overlay"></div>
              <div class="d-flex h-100 flex-column  justify-content-center">
                <div class="p-4">
                  <div class="row justify-content-center">
                    <div class="col-lg-7">
                      <div class="text-center">
                        <div class="logo-auth mb-4">
                          <img src="~@/assets/images/logo/logo-light.png" alt="" />
                        </div>
                        <div dir="ltr" class="owl-theme">
                          <b-carousel
                            id="carousel-1"
                            :interval="4000"
                            indicators
                          >
                            <b-carousel-slide>
                              <h2 class=" text-white text-capitalize">
                                Nền tảng gọi vốn doanh nghiệp hàng đầu
                              </h2>
                            </b-carousel-slide>
                            <b-carousel-slide>
                              <h2 class=" text-white text-capitalize">
                                Cam kết an toàn, đầu tư hiệu quả
                              </h2>
                            </b-carousel-slide>
                            <b-carousel-slide>
                              <p>
                                Luôn nỗ lực tìm kiếm và phát hiện những cơ hội
                                đầu tư mới, gắn kết những cơ hội này với các
                                nguồn lực tài chính, biến cơ hội thành doanh thu
                                trong tầm tay, đem lại hiệu quả tối ưu cho khách
                                hàng, cộng sự, đối tác, cổ đông và cộng đồng.
                              </p>
                              <h2 class=" text-white text-capitalize">
                                Chúng ta cùng thành công
                              </h2>
                            </b-carousel-slide>
                          </b-carousel>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-5 order-1 order-lg-2">
          <div class="auth-full-page-content p-md-5 p-4">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.auth-full-page-content {
  background: linear-gradient(to right, #003395, #008cff);
}
.logo-auth {
  img {
    max-width: 300px;
    width: 100%;
    height: auto;
    @media (max-width: 1439px) {
      max-width: 200px;
    }
  }
}
</style>
